<template>
  <div id="app" class="min-h-screen flex flex-col bg-gray-200">
    <div class="flex-grow bg-[#112044]">
      <router-view />
    </div>
    <div class="h-2 bg-[#044e7d]"></div>
    <FooterSection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterSection from '@/components/FooterSection.vue'

export default defineComponent({
  name: 'App',
  components: {
    FooterSection
  }
});
</script>
